<template>
  <div>
    <el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
      <el-form :inline="true" v-if="Limits.task_create">
        <el-form-item>
          <!--<el-input v-if="Limits.task_create" v-model="inputCode" placeholder="请输入任务单号" size="small"-->
          <!--style="width: 130px;"></el-input>-->
          <el-date-picker
            v-if="Limits.task_create"
            v-model="inputCode"
            align="right"
            type="date"
            size="small"
            value-format="yyyy-MMdd"
            placeholder="请选择任务单创建日期"
            style="width: 200px;"
            :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span>流水号：</span>
          <el-input-number v-model="inputSeriesNum" :min="1" :max="99" label="流水号" size="mini" controls-position="right"
                           style="width: 100px;"/>
        </el-form-item>
        <el-form-item>
          <el-input v-model="inputNum" placeholder="请输入本批次设备数" size="small" style="width: 155px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="Productvalue" placeholder="请选择产品类型" @change="Vervalue = ''" size="small"
                     style="width: 140px;">
            <el-option v-for="item in ProductCodeList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="Vervalue" v-show="Productvalue !=''" placeholder="请选择版本" size="small"
                     style="width: 130px;">
            <el-option v-for="item in EditionCodeList[Productvalue]" :key="item.value"
                       :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="Create" :loading="Cteatloading">生成任务单</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="SearchCode" placeholder="请输入任务单号" prefix-icon="el-icon-search"
                    size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="Find" icon="el-icon-search">查询</el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="List" border v-loading="listloading" style="width: 99.9%;" :max-height="maxHeight">
      <el-table-column prop="serial_number" label="任务单号"></el-table-column>
      <el-table-column prop="count" label="数量"></el-table-column>
      <el-table-column prop="product" label="产品"></el-table-column>
      <el-table-column prop="edition" label="版本"></el-table-column>
      <!--		    <el-table-column prop="post_date" label="生成时间" width="170" :formatter="dateFormat"></el-table-column>-->
      <el-table-column label="操作" width="120" v-if="Limits.task_view || Limits.task_delete">
        <template slot-scope="scope">
          <el-button v-if="Limits.task_view" type="primary" size="mini"
                     @click="GodownCode(scope.$index,scope.row)">详情
          </el-button>
          <!--<el-button v-if="Limits.task_delete" type="danger" icon="el-icon-delete" size="mini" style="padding: 7px;" @click="Delete(scope.$index,scope.row)"></el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar downtool">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize"
                     :current-page="Curpage" :total="total" style="float:right;">
      </el-pagination>
    </el-col>

    <el-dialog title="下载二维码" :visible.sync="QrcodeVisible" :fullscreen="true">
      <el-button v-if="Limits.task_qrcodes" type="warning" style="margin-bottom: 10px;" @click="DownAll">
        打包下载此单所有设备二维码
      </el-button>
      <el-table :data="List2" border v-loading="listloading2">
        <!--@selection-change="selsChange"-->
        <!--<el-table-column v-if="Limits.task_qrcodes" type="selection" width="50" :selectable='checkboxInit' prop='download_count'></el-table-column>-->
        <el-table-column label="DID" prop="did"></el-table-column>
        <el-table-column label="版本" prop="edition"></el-table-column>
        <el-table-column label="颜色" prop="color"></el-table-column>
        <!--<el-table-column label="产品" prop="product"></el-table-column>-->
        <el-table-column label="气弹簧" prop="spring"></el-table-column>
        <!--				<el-table-column label="绑定时间" prop="bind_time" :formatter="dateFormat"></el-table-column>-->
        <!--<el-table-column label="操作" width="80">
            <template slot-scope="scope">
                <el-button size="small" type="danger">删除</el-button>
            </template>
        </el-table-column>-->
      </el-table>

      <el-col :span="24" class="toolbar">
        <!--<el-button v-if="Limits.task_qrcodes" type="primary" :disabled="this.sels.length === 0"  @click="Download" size="small">点击下载</el-button>-->
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2"
                       :current-page="Curpage2" :total="total2" style="float:right;">
        </el-pagination>
      </el-col>
    </el-dialog>
  </div>
</template>

<script>
  import {GetTasklist, GetDevicelist} from '../api/api';
  import FileSaver from 'file-saver'

  export default {
    data() {
      return {
        token: "",
        maxHeight: 600,
        Limits: "",
        inputCode: "",
        inputSeriesNum: '',
        inputNum: "",
        Productvalue: "",
        Vervalue: "",
        SearchCode: "",
        List: [],
        listloading: false,
        total: 1,
        Curpage: 1,
        Pagesize: 20,
        Cteatloading: false,
        listloading2: false,
        QrcodeVisible: false,
        List2: [],
        total2: 1,
        Curpage2: 1,
        Pagesize2: 20,
        sels: [],
        Form: {
          id: ""
        },
        pickerOptions1: {
          disabledDate(time) {
            return time.getTime() > Date.now() || time.getTime() < new Date(2017, 0, 1).getTime();
          },
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        },
        ProductCodeList: [
          {
            label: "邦邦车",
            value: "A"
          },
          {
            label: "智能轮椅",
            value: "B"
          }
        ],
        EditionCodeList: {
          A: [{label: "标准版", value: 1},
            {label: "运动舒适版", value: 2},
            {label: "运动基本版", value: 3},
            {label: "运动豪华版", value: 4},
            {label: "运动工伤版", value: 5},
            {label: "运动旗舰版", value: 6},
            {label: "电动推杆", value: 7},
            {label: "运动lite版", value: 8},
            {label: "儿童版", value: 9},],
          B: [{label: "V1", value: 1}]
        }
      }
    },
    methods: {
      Create() {
        // 任务单编号解析转换
        let inputDate = this.inputCode
        let year = inputDate.split('-')[0]
        let monthday = inputDate.split('-')[1]
        let yearLetter = String.fromCharCode('A'.charCodeAt(0) + (year - 2017))// 2017-A,2018-B,2019-C,2020-D
        this.inputCode = yearLetter + monthday + (Array(2).join('0') + this.inputSeriesNum).slice(-2);

        if (this.inputCode && this.inputNum && this.Productvalue && this.Vervalue) {
          this.Cteatloading = true
          this.inputCode = this.inputCode.toUpperCase()
          if (this.inputCode && this.inputNum && this.Productvalue && this.Vervalue) {
            let para = {
              serial_number: this.inputCode,
              count: this.inputNum,
              product_code: this.Productvalue,
              edition_code: this.Vervalue
            }

            let url = "/tasks?token=" + this.token
            this.axios.post(url, para).then(res => {
              console.log(res)
              if (res.status == "201") {
                this.$message({
                  type: 'success',
                  message: '操作成功!'
                });
                this.Cteatloading = false
                this.GetList(GetTasklist, {page: this.Curpage, token: this.token, sort: "-id"})
              } else {
                this.$message.error("对不起，请求失败。")
                this.Cteatloading = false
              }

            }).catch(err => {
              this.$message.error(err.response.data.message)
              this.Cteatloading = false
            })
          }
        } else {
          this.$message.error("请认真填写任务单四项信息并再次提交。")
        }

      },
      Find() {
        if (this.SearchCode) {
          this.GetList(GetTasklist, {
            page: this.Curpage,
            token: this.token,
            sort: "-id",
            q: JSON.stringify([{"AND": {"serial_number": '~' + this.SearchCode}}])
          })
        }
      },
      Refresh() {
        this.SearchCode = ""
        this.inputCode = ""
        this.inputNum = ""
        this.Productvalue = ""
        this.Vervalue = ""
        this.Curpage = 1
        this.GetList(GetTasklist, {page: this.Curpage, token: this.token, sort: "-id"})
      },
      handleCurrentChange(val) {
        this.Curpage = val
        if (this.SearchCode) {
          this.GetList(GetTasklist, {
            page: this.Curpage,
            token: this.token,
            sort: "-id",
            q: JSON.stringify([{"AND": {"serial_number": '~' + this.SearchCode}}])
          })
        } else {
          this.GetList(GetTasklist, {page: this.Curpage, token: this.token, sort: "-id"})
        }
      },
      GodownCode(index, row) {
        this.Curpage2 = 1
        this.Form = Object.assign({}, row);
        this.QrcodeVisible = true
        this.GetList2(GetDevicelist, {
          page: this.Curpage2,
          token: this.token,
          q: JSON.stringify([{"AND": {"task_id": this.Form.id}}])
        })
//				this.listloading2 = true
//				this.QrcodeVisible = true
//				let url = "/tasks/" + this.Form.id
//				this.axios.get(url,{
//					params:{
//						token:this.token,
//						expand:"devices"
//					}
//				}).then(res => {
//					if(res.status == "200"){
//						console.log(res)
//						this.List2 = res.data.devices
//						this.total2 = res.data.count
//						this.listloading2 = false
//					}else{
//						this.$message.error('对不起，请求失败。')
//					}
//				}).catch(err => {
//					this.$message.error(err.response.data.message)
//				})
      },
      shua2() {
        this.Curpage2 = 1
        this.listloading2 = true
        let url = "/tasks/" + this.Form.id
        this.axios.get(url, {
          params: {
            token: this.token,
            expand: "devices"
          }
        }).then(res => {
          if (res.status == "200") {
            console.log(res)
            this.List2 = res.data.devices
            this.total2 = res.data.count
            this.listloading2 = false
          } else {
            this.$message.error('对不起，请求失败。')
          }
        }).catch(err => {
          this.$message.error(err.response.data.message)
        })
      },
      selsChange(sels) {
        this.sels = sels;
      },
      checkboxInit(row, index) {
        if (row.is_download == '是') {
          return 0;//不可勾选
        } else {
          return 1;//可勾选
        }
      },
      handleCurrentChange2(val) {
        this.Curpage2 = val
        this.GetList2(GetDevicelist, {
          page: this.Curpage2,
          token: this.token,
          q: JSON.stringify([{"AND": {"task_id": this.Form.id}}])
        })
      },
      Download(index, row) {
        var sids = this.sels.map(item => item.sid.slice(9, 12));
        sids = (sids + "").replace(/\[|]/g, '')
        console.log(sids)
//				let url = "/tasks/" + this.Form.id + "/qrcodes"
        console.log("QrCodeUrl", this.QrCodeUrl)
        let url = this.QrCodeUrl + "/tasks/" + this.Form.id + "/qrcodes?token=" + this.token + "&sids=" + sids
//				+ this.token + "&sids=" + sids
//				console.log(url)
        location.href = url
//				this.axios.get(url,{
//					params:{
//						token:this.token,
//						sids:sids
//					}
//				}).then(res => {
//					console.log("res",res)
//				}).catch(err =>{
//					console.log(err)
//				})
        this.GetList2(GetDevicelist, {
          page: this.Curpage2,
          token: this.token,
          q: JSON.stringify([{"AND": {"task_id": this.Form.id}}])
        })
      },
      DownAll() {
        var that = this
        var cmd = 0
        for (var i = 0; i < that.List2.length; i++) {
          if (this.List2[i].is_download == '是') {
            cmd = 1
          }
        }
        if (cmd == 1) {
          this.$message.error("该任务单中存在已下载二维码，不能使用此功能。")
        } else {
//					let url = this.QrCodeUrl + "/tasks/" + this.Form.id + "/qrcodes?token=" + this.token
//					
//					var $eleForm = $("<form method='get'></form>");
// 
//		            $eleForm.attr("action",url);
//		 
//		            $(document.body).append($eleForm);
//		 
//		            //提交表单，实现下载
//		            $eleForm.submit();


          console.log("QrCodeUrl", this.QrCodeUrl)
          let url = this.QrCodeUrl + "/tasks/" + this.Form.id + "/qrcodes?token=" + this.token
          location.href = url
//					this.shua2()
        }

      },
      Delete(index, row) {
        this.$confirm('确认删除该任务单及所有设备?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.Form = Object.assign({}, row);
          let u = "/tasks/" + this.Form.id
          this.Del(u, GetTasklist, {page: this.Curpage, token: this.token, sort: "-id"})
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        })

      },
    },
    created() {
      console.log("this.QrCodeUrl", this.QrCodeUrl)
      this.token = sessionStorage.getItem("BBRtoken");
      this.Limits = JSON.parse(sessionStorage.getItem("limits"))
      this.GetList(GetTasklist, {page: this.Curpage, token: this.token, sort: "-id"})
    },
    mounted() {
      this.$nextTick(function () {
        this.Gethigh()
      })
    }
  }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// EquipmentBelow.vue?35471e32